import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

@Injectable()
export class HeaderService {
  private readonly headerHiddenSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get headerHidden$(): Observable<boolean> {
    return this.headerHiddenSubject$.asObservable().pipe(distinctUntilChanged());
  }

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(
        filter((routerEvent) => routerEvent instanceof NavigationEnd),
        tap(() => this.onShow()),
      )
      .subscribe();
  }

  onHide(): void {
    this.headerHiddenSubject$.next(true);
  }

  onShow(): void {
    this.headerHiddenSubject$.next(false);
  }
}
